export default __webpack_public_path__ + "static/media/eyeOn.145335af.svg";